module.exports = __webpack_public_path__ + "media/images/announceGroup__textBg-06cd2bc11673c9125fc99e95beac6cb1.png";